/**
 * @format
 */

/* eslint-disable no-useless-escape */

/**
 * Remove Tags
 *
 * @format
 * @param {string} str
 * @return {string}
 */
export const removeTags = (str: string | null): string | null => {
  if (str === null || str === '') {
    return null;
  }
  return str.replace(/(<([^>]+)>)/gi, '');
};

/**
 * Special Character Check.
 *
 * @format
 * @param {string} str
 * @return {string}
 */
export const htmlToCharacterCheck = (
  str: string | null | undefined
): string | null => {
  if (str) {
    return str
      .replace(/&amp;/g, '&')
      .replace(/&#039;/g, "'")
      .replace(/&quot;/g, '"')
      .replace(/&nbsp;/g, '\u00a0');
  }
  return null;
};

/**
 * Clear and Uppercase.
 * @param {string} text
 * @return {string|null}
 */
export const clearAndUpperCase = (text?: string): string | null => {
  if (text) {
    return text.replace(/-/, '').toUpperCase();
  }
  return null;
};

/**
 * To Camel Case.
 *
 * @param {string} text
 * @return {string|null}
 */
export const toCamelCase = (text?: string): string | null => {
  if (text) {
    return text.replace(/-\w/g, clearAndUpperCase);
  }
  return null;
};

/**
 * To Pascal Case
 *
 * @param {string} text
 * @return {string|null}
 */
export const toPascalCase = (text?: string): string | null => {
  if (text) {
    return text.replace(/(^\w|-\w)/g, clearAndUpperCase);
  }
  return null;
};

/**
 * Uppercase first character in all words.
 *
 * @param {string} text
 * @return {string|null}
 */
export const uppercaseFirstCharacters = (text?: string): string | null => {
  if (text) {
    return text.toLowerCase().replace(/(?:_|\b)(\w)/g, function (text, p1) {
      return p1.toUpperCase();
    });
  }
  return null;
};

/**
 * Get Break Space Index. Used for adding ellipses after spaces are found.
 *
 * @param {string} content
 * @param {number} textLength
 * @return
 */
export const getBreakSpaceIndex = (content: string, textLength: number) => {
  if (content.length > textLength) {
    const subContent = content.substring(textLength);
    return subContent.indexOf(' ');
  }
  return null;
};

/**
 * Sanitize JSON string safely.
 *
 * @param {string} json
 * @return {object}
 */
export const sanitizeJson = (json: string) => {
  const regexTrailingComma = /\,(?!\s*?[\{\[\"\'\w])/g;
  const regexLineBreaks = /\r?\n|\r/g;
  const sanitizedJson = json
    .replace(regexTrailingComma, '')
    .replace(regexLineBreaks, '');
  try {
    return JSON.parse(sanitizedJson);
  } catch {
    return null;
  }
};

/**
 * Unescape HTML
 *
 * @param {string} htmlString
 * @return {string|null}
 *   Unescaped HTML string.
 */
export const unescapeHtml = (htmlString?: string): string | null => {
  if (htmlString) {
    htmlString = htmlString.replace(/&lt;/g, '<');
    htmlString = htmlString.replace(/&gt;/g, '>');
    htmlString = htmlString.replace(/&quot;/g, '"');
    htmlString = htmlString.replace(/&#39;/g, "'");
    htmlString = htmlString.replace(/&amp;/g, '&');
    return htmlString;
  }
  return null;
};
